export default defineNuxtPlugin(async () => {
  const appStatStore = useAppStatStore()
  const appDataStore = useAppDataStore()

  await appStatStore.fetchStats()
  await appDataStore.fetchData()
})
